import { render } from "./TanstackTable.vue?vue&type=template&id=1d6aa0a6&scoped=true"
import script from "./TanstackTable.vue?vue&type=script&lang=js"
export * from "./TanstackTable.vue?vue&type=script&lang=js"

import "./TanstackTable.vue?vue&type=style&index=0&id=1d6aa0a6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3829526335/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6aa0a6"]])

export default __exports__